import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import * as Logger from 'js-logger';
import template from './footer.vue';
import $ from 'jquery';

@Component({
    mixins: [template],
})

export default class Footer extends Vue {

    created() {
        // When the component gets created.
    }

    mounted() {

    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/components/footer/index.ts